import React, { useState } from 'react'
import { ComponentView } from 'components/common/componentView'
import { config } from 'configs'
import {
  // FavouriteList,
  InactiveList,
  // ProgramList,
  MyPrograms,
} from './components/ProgramLists'

const Programs = () => {
  const [searchText, setSearchText] = useState(null)
  const [sortSwitchValue, setSortSwitchValue] = useState(false)
  const [sortKey, setSortKey] = useState('CreatedDate')

  const heading = 'Programs'
  const optionList = {
    // all: <ProgramList searchText={searchText} />,
    my: <MyPrograms searchText={searchText} />,
    inactive: <InactiveList searchText={searchText} />,
    // favorite: <FavouriteList searchText={searchText} sortKey={sortKey} />,
  }
  const createButtonLink = '/settings/create-program'

  const sortFilterData = [
    {
      label: 'By Created Date',
      value: 'CreatedDate',
      onlyShowOn: 'favorite',
      showOn: ['favorite'],
    },
    {
      label: 'By Favorite Date',
      value: 'favDate',
      showOn: ['favorite'],
    },
  ]

  return (
    <ComponentView
      component={config.components.program}
      heading={heading}
      optionList={optionList}
      createButtonLink={createButtonLink}
      setSearchText={setSearchText}
      sortFilterData={sortFilterData}
      sortKey={sortKey}
      setSortKey={setSortKey}
      sortSwitchValue={sortSwitchValue}
      setSortSwitchValue={setSortSwitchValue}
    />
  )
}

export { Programs }
